import { API, APIFORMDATA } from "../../utils/CommunityAPIUtils";

export const getFeedsAPIHelper = async (params) => {
  try {
    const response = await API.get(`/api/posts`, { params: params });
    return {
      data: response.data.data,       // actual feeds array
      pagination: response.data.pagination  // pagination info
    };
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getMyFeedsAPIHelper = async (params) => {
  try {
    const response = await API.get(`/api/posts`, {
      params: { my_posts: true, ...params },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getSingleFeedAPIHelper = async (id) => {
  try {
    const response = await API.get(`/api/posts/${id}`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const postFeedAPIHelper = async (payload) => {
  try {
    const response = await APIFORMDATA.post(`/api/posts`, payload);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const updateFeedAPIHelper = async (payload) => {
  try {
    const { id, data } = payload;
    const response = await APIFORMDATA.patch(`/api/posts/${id}`, data);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const deleteFeedAPIHelper = async (id) => {
  try {
    const response = await APIFORMDATA.delete(`/api/posts/${id}`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const likeFeedAPIHelper = async (id) => {
  try {
    const response = await API.post(`/api/posts/${id}/like`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const postFeedCommentAPIHelper = async (params) => {
  const { id, ...content } = params;
  try {
    const response = await API.post(`/api/posts/${id}/comments`, content);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getFeedCommentAPIHelper = async (id) => {
  try {
    const response = await API.get(`/api/posts/${id}/comments`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const updateFeedCommentAPIHelper = async (params) => {
  const { id, commentId, ...content } = params;
  try {
    const response = await API.patch(
      `/api/posts/${id}/comments/${commentId}`,
      content
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const deleteFeedCommentAPIHelper = async (params) => {
  const { id, commentId } = params;
  try {
    const response = await APIFORMDATA.delete(
      `/api/posts/${id}/comments/${commentId}`
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const postFeedCommentReplayAPIHelper = async (params) => {
  const { id, commentId, ...content } = params;
  try {
    const response = await API.post(
      `/api/posts/${id}/comments/${commentId}/replies`,
      content
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const updateFeedCommentReplayAPIHelper = async (params) => {
  const { id, commentId, replyId, ...content } = params;
  try {
    const response = await API.patch(
      `/api/posts/${id}/comments/${commentId}/replies/${replyId}`,
      content
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const deleteFeedCommentReplayAPIHelper = async (params) => {
  const { id, commentId, replyId } = params;
  try {
    const response = await APIFORMDATA.delete(
      `/api/posts/${id}/comments/${commentId}/replies/${replyId}`
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const updateFeedCommentLikeAPIHelper = async (params) => {
  const { id, commentId } = params;
  try {
    const response = await API.patch(
      `/api/posts/${id}/comments/${commentId}/like`
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const updateFeedCommentReplayLikeAPIHelper = async (params) => {
  const { id, commentId, replyId } = params;
  try {
    const response = await API.patch(
      `/api/posts/${id}/comments/${commentId}/replies/${replyId}/like`
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

//Events

export const postEventAPIHelper = async (payload) => {
  try {
    const response = await APIFORMDATA.post(`/api/events`, payload);
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateEventAPIHelper = async (payload) => {
  try {
    const { id, data } = payload;
    const response = await APIFORMDATA.patch(`/api/events/${id}`, data);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getEventsAPIHelper = async (params) => {
  try {
    const response = await API.get(`/api/events`, { params: params });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getSingleEventAPIHelper = async (id) => {
  try {
    const response = await API.get(`/api/events/${id}`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const deleteEventAPIHelper = async (id) => {
  try {
    const response = await APIFORMDATA.delete(`/api/events/${id}`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const throttle = (func, limit) => {
  let inThrottle;
  return function () {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
};

export const registerForEventAPIHelper = async (params) => {
  const { eventId, ...attendees } = params;
  try {
    const response = await API.post(
      `/api/events/${eventId}/register`,
      attendees
    );
    return response;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getEventAttendeesAPIHelper = async (eventId) => {
  try {
    const response = await API.get(`/api/events/${eventId}/attendees`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getRegisteredEventAPIHelper = async (params) => {
  try {
    const response = await API.get(`/api/events/registered`, {
      params: params,
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getRegisteredEventHistoryAPIHelper = async (params) => {
  try {
    const response = await API.get(`/api/events/registered`, {
      params: params,
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getAttendeeAccessAPIHelper = async (ticketId) => {
  try {
    const response = await API.get(`/api/events/access/${ticketId}`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const PatchAttendeeAccessAPIHelper = async (payload) => {
  try {
    const response = await API.patch(`/api/events/access/${payload.ticketId}`, payload.payload);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const transferTicketAPIHelper = async (payload) => {
  // const { ticketId, payload: transferPayload } = payload;
  try {
    const response = await API.patch(
      `/api/events/access/${payload.ticketId}/transfer`,
      payload.payload
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};


export const cancelTicketAPIHelper = async (payload) => {
  // const { ticketId, payload: transferPayload } = payload;
  try {
    const response = await API.patch(
      `/api/events/access/${payload.ticketId}/cancel`,
      payload.payload
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};


export const getExploreAllAPIHelper = async (params) => {
  try {
    const response = await API.get(`/api/explore`, { params: params });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const postInviteUserstoEventAPIHelper = async (params) => {
  const { id, userIds } = params;

  try {
    const response = await API.post(`/api/events/${id}/invite-users`, {
      invited_user_ids: userIds
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const removeUsersFromInviteListAPIHelper = async (params) => {
  // console.log("paramsYYYY", params)

  try {
    const response = await API.delete(`/api/events/${params.id}/invite-users`, {
      params: { invitation_ids: params.invitation_ids },
    });
    return response.data;
  } catch (error) {
    console.log("IAMERROR", error)
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getInviatedUsersEventAPIHelper = async (params) => {
  const { id } = params
  try {
    const response = await API.get(`/api/events/${id}/invite-users`, { params: params });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

// Get Event Analytics
export const getEventAnalyticsAPIHelper = async (id) => {
  try {
    const response = await API.get(`/api/events/${id}/analytics`);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

// ================= VOLUNTEER APIS =================

export const getEventAccessLogsAPIHelper = async (params) => {
  try {
    const response = await API.get(
      `/api/events/${params?.eventId}/access/logs`,
      { params },
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const postVolunteerAPIHelper = async (payload) => {
  try {
    const response = await API.post(`/api/events/volunteers`, payload);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getVolunteersAPIHelper = async (eventId) => {
  try {
    const response = await API.get(`/api/events/${eventId}/volunteers`);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getVolunteerByIdAPIHelper = async (id) => {
  try {
    const response = await API.get(`/api/events/volunteers/${id}`);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteVolunteerByIdAPIHelper = async (id) => {
  try {
    const response = await API.delete(`/api/events/volunteers/${id}`);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};